import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props}
    viewBox={'0 0 512 512'}>
        <path

            stroke={"#4895EF"}
            fill={"#4895EF"}
            viewBox={`0 0 512 512`}
            d="M232 368c-31 0-56-25-56-56s25-56 56-56 56 25 56 56-25 56-56 56zm0-96c-22 0-40 18-40 40s18 40 40 40 40-18 40-40-18-40-40-40zm38 66 64 64-12 12-64-64zm170 174H72V136h368zM88 496h336V152H88zm256-304h-16V88c0-40-32-72-72-72s-72 32-72 72v104h-16V88c0-49 39-88 88-88s88 39 88 88z" />
    </svg>
)

export default SvgComponent
